import { MatSnackBarConfig } from '@angular/material/snack-bar';

export enum NotificationType {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success'
}

export class NotificationConfig extends MatSnackBarConfig {
  constructor(notice: any, type: NotificationType, permanent = false, hideDismiss = false, action?: (...args: any[]) => any) {
    super();

    this.data = {
      id: 'notification-display',
      notice,
      hideDismiss,
      action,
    };
    this.panelClass = ['bar-notification', type];
    this.verticalPosition = 'top';
    this.duration = permanent ? 0 : 3000;
  }
}
